export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="控件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="控件/导航-搜索栏" transform="translate(-1047.000000, -22.000000)">
                    <g id="btn/buy备份-2" transform="translate(1039.000000, 15.000000)">
                        <rect id="矩形" x="0" y="0" width="30" height="30"></rect>
                        <path
                            d="M15.4413604,6.35857864 L15.4403604,14.5585786 L23.6414214,14.5585786 L23.6414214,15.1585786 L15.4403604,15.1585786 L15.4413604,23.3585786 L14.8413604,23.3585786 L14.8403604,15.1585786 L6.64142136,15.1585786 L6.64142136,14.5585786 L14.8403604,14.5585786 L14.8413604,6.35857864 L15.4413604,6.35857864 Z"
                            id="形状结合"
                            stroke="currentColor"
                            fill="currentColor"
                            transform="translate(15.141421, 14.858579) rotate(45.000000) translate(-15.141421, -14.858579) "
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
